import { IMobileComparePageId } from '@/pages/intelligence/types/mobileCompare';

export const DEFAULT_FILTER_PARAMS = {
  dataSource: ['sensortower'],
  regionType: 'region',
  regionValue: ['global'],
  showHeatMap: false,
  showCountries: false,
};

// 点击游戏 跳转到游戏详情页时，游戏详情页tab的映射
export const GAME_DETAILS_TABS: {
  [key in IMobileComparePageId]: string;
} = {
  dau: 'stats',
  revenue: 'stats',
  download: 'stats',
  storeRank: 'storeRank',
};

// 点击游戏 跳转到游戏详情页时，游戏详情页子tab的映射
export const GAME_DETAILS_SUB_TABS: {
  [key in IMobileComparePageId]: string;
} = {
  dau: 'activeusers',
  revenue: 'revenue',
  download: 'downloads',
  storeRank: 'storerank',
};

export const Key_Metrics_Map: {
  [key: string]: string;
} = {
  dau: 'dbi_active_users',
  revenue: 'dbi_revenue',
  download: 'dbi_downloads',
};
